import { useState } from 'react'
import autoAnimate from '@formkit/auto-animate'
import React, { useEffect, useRef } from 'react'
import HubspotForm from 'react-hubspot-form'
import StepQuestion from './StepQuestion'
import Button from '../../Button/Button'

const StepThree = ({ question, setStep, setLoading }) => {
    const [submitted, setSubmitted] = useState(false)
    // useEffect(() => {
    //     // Dynamically load the gtag.js script
    //     const script = document.createElement('script');
    //     script.async = true;
    //     script.src = `https://www.googletagmanager.com/gtag/js?id=AW-786473858`;
    //     document.head.appendChild(script);

    //     // Initialize gtag
    //     script.onload = () => {
    //       window.dataLayer = window.dataLayer || [];
    //       function gtag() {
    //         window.dataLayer.push(arguments);
    //       }
    //       gtag('js', new Date());
    //       gtag('config', 'AW-786473858');
    //     };
    //   }, []);

    const hubspotRef = useRef(null)
    useEffect(() => {
        hubspotRef.current && autoAnimate(hubspotRef.current)
    }, [hubspotRef])
    return (
        <>
            <fieldset id="assessment-form-wrapper">
                <StepQuestion question={question} />

                <div
                    className="cyber-assessment-tool-form mt-10 space-y-3"
                    ref={hubspotRef}
                >
                    <HubspotForm
                        portalId={'2642977'}
                        formId={'cf7a3f55-2e6f-467a-8cb6-e2c061f0b671'}
                        onFormSubmitted={() => {
                            setSubmitted(true)
                            console.log('Cyber Assessment Tool Form submitted!')
                            document.getElementById('thankyou').style.display =
                                'block';
                            document.getElementById('assessment-form-wrapper').style.display =
                                'none';
                            setStep((pre) => pre + 1)
                            setLoading(false)
                            if (typeof window.gtag !== 'undefined') {
                                window.gtag('event', 'conversion', {
                                    send_to:
                                        'AW-786473858/Zy9iCKWut9gZEILHgvcC',
                                    value: 1.0,
                                    currency: 'GBP'
                                })
                            } else {
                                console.error('gtag not defined')
                            }
                        }}
                        // onform
                        loading={
                            <div className="mx-auto w-full rounded-md border border-dark_purple_2/30 p-4 shadow">
                                <div className="flex animate-pulse space-x-4">
                                    <div className="flex-1 space-y-6 py-1">
                                        <div className="grid grid-cols-2 gap-4">
                                            <div className=" h-5 rounded-[50px] bg-gray-200" />
                                            <div className=" h-5 rounded-[50px] bg-gray-200" />
                                        </div>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div className=" h-5 rounded-[50px] bg-gray-200" />
                                            <div className=" h-5 rounded-[50px] bg-gray-200" />
                                        </div>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div className=" h-5 rounded-[50px] bg-gray-200" />
                                            <div className=" h-5 rounded-[50px] bg-gray-200" />
                                        </div>
                                        <div className="h-5 rounded-[50px] bg-gray-200" />
                                        <div className="h-5 rounded-[50px] bg-gray-200" />
                                    </div>
                                </div>
                            </div>
                        }
                    />
                </div>
            </fieldset>
          
                <div id="thankyou" className="text-center hidden">
                    <h3 className="mb-2 block text-3xl text-vivid_raspberry lg:text-[32px] lg:leading-[38px]">
                        Last step:
                    </h3>
                    <span className="mb-1 block font-grotesk-medium text-3xl leading-snug lg:text-[32px]">
                        Thank you for completing the assessment
                    </span>
                    <span className="block font-grotesk-regular text-2xl">
                        We will send the result to your email shortly!
                    </span>

                    <Button
                        buttonLink={{ url: '/' }}
                        className="mt-14 px-[38px] py-4"
                        styles={'secondary'}
                    >
                        Homepage
                    </Button>
                </div>
            
        </>
    )
}

export default StepThree
